<template>
  <div class="card">
    <div class="card-header">
      <h1>Cambiar contraseña</h1>
    </div>
    <div class="card-body">
      <form ref="password_form" @submit.prevent="handleChangePassword">
        <base-input
          v-model="password"
          type="password"
          name="new_password"
          autocomplete="on"
          class="mb-3"
          prepend-icon="fa fa-key"
          placeholder="Nueva Contraseña"
        />
        <validation-error :errors="apiValidationErrors.password" />

        <base-input
          v-model="password_confirmation"
          type="password"
          name="confirm_password"
          autocomplete="on"
          class="mb-3"
          prepend-icon="fa fa-key"
          placeholder="Confirmar Contraseña"
        />
        <validation-error :errors="apiValidationErrors.password_confirmation" />
        <div class="my-4">
          <base-button
            type="button"
            class="btn hover-apolo btn-sm btn-default"
            native-type="submit"
          >
            Cambiar Contraseña
          </base-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";

export default {
  name: "UserPasswordCard",

  components: {
    BaseInput,
    BaseButton,
    ValidationError,
  },

  mixins: [formMixin],

  props: {
    user: Object,
  },

  data() {
    return {
      password: null,
      password_confirmation: null,
    };
  },

  methods: {
    async handleChangePassword() {

      this.user.attributes.password = this.password;
      this.user.attributes.password_confirmation = this.password_confirmation;

      try {
        await this.$store.dispatch("profile/updatePassword", this.user);
        this.$refs["password_form"].reset();
        this.resetApiValidation();
        this.password = null;
        this.password_confirmation = null;

        this.$notify({
          type: "success",
          message: "Contraseña cambiada satisfactoriamente.",
          duration: -1
        });
      } catch (error) {
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
        this.resetApiValidation();
        this.setApiValidation(error.response.data.errors);
        this.password = null;
        this.password_confirmation = null;
      }
    },
  },
};
</script>
